// Author Shi Wen Long
// Date 2021-12-01 16:08:32

import {getModelTaxRates,getModelPaymentTerms,getModelDeliverTerms} from "@/model/sithMes/stool/TermsAndTaxRate.js";

class SithMesStoolVendor {
constructor({
        id = null,
        vendor = '',
        centralDeletion = '',
        companyCode = '',
        companyCodeDeletion = '',
        dataCommunicationLine = '',
        terms = '',
        chName = '',
        enName = '',
        email = '',
        tel = '',
        deliverTerms = '',
        taxRate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.vendor = vendor;
    this.centralDeletion = centralDeletion;
    this.companyCode = companyCode;
    this.companyCodeDeletion = companyCodeDeletion;
    this.dataCommunicationLine = dataCommunicationLine;
    this.terms = terms;
    this.chName = chName;
    this.enName = enName;
    this.email = email;
    this.tel = tel;
    this.deliverTerms = deliverTerms;
    this.taxRate = taxRate;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesStoolVendor();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.stool.sithMesStoolVendor.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'vendor',
        label: 'label.sith.stool.sithMesStoolVendor.grid.vendor',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'centralDeletion',
        label: 'label.sith.stool.sithMesStoolVendor.grid.centralDeletion',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'companyCode',
        label: 'label.sith.stool.sithMesStoolVendor.grid.companyCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'companyCodeDeletion',
        label: 'label.sith.stool.sithMesStoolVendor.grid.companyCodeDeletion',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'dataCommunicationLine',
        label: 'label.sith.stool.sithMesStoolVendor.grid.dataCommunicationLine',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'terms',
        label: 'label.sith.stool.sithMesStoolVendor.grid.terms',
        sortable: true,
        form: {
                type: 'select',
                options: getModelPaymentTerms()
        }
        },
        {
        key: 'chName',
        label: 'label.sith.stool.sithMesStoolVendor.grid.chName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'enName',
        label: 'label.sith.stool.sithMesStoolVendor.grid.enName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'email',
        label: 'label.sith.stool.sithMesStoolVendor.grid.email',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tel',
        label: 'label.sith.stool.sithMesStoolVendor.grid.tel',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'deliverTerms',
        label: 'label.sith.stool.sithMesStoolVendor.grid.deliverTerms',
        sortable: true,
        form: {
                type: 'select',
                options: getModelDeliverTerms()
        }
        },
        {
        key: 'taxRate',
        label: 'label.sith.stool.sithMesStoolVendor.grid.taxRate',
        sortable: true,
        form: {
            type: 'select',
            options: getModelTaxRates()
        }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolVendor.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    vendorFilter : '',
    centralDeletionFilter : '',
    companyCodeFilter : '',
    companyCodeDeletionFilter : '',
    dataCommunicationLineFilter : '',
    termsFilter : '',
    chNameFilter : '',
    enNameFilter : '',
    emailFilter : '',
    telFilter : '',
    deliverTermsFilter : '',
    taxRateFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'vendorFilter',
        label: 'label.sith.stool.sithMesStoolVendor.filter.vendor',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'centralDeletionFilter',
        label: 'label.sith.stool.sithMesStoolVendor.filter.centralDeletion',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'companyCodeFilter',
        label: 'label.sith.stool.sithMesStoolVendor.filter.companyCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'companyCodeDeletionFilter',
        label: 'label.sith.stool.sithMesStoolVendor.filter.companyCodeDeletion',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dataCommunicationLineFilter',
        label: 'label.sith.stool.sithMesStoolVendor.filter.dataCommunicationLine',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'termsFilter',
        label: 'label.sith.stool.sithMesStoolVendor.filter.terms',
        disabled: false,
        form: {
                type: 'select',
                options: getModelPaymentTerms()
        }
        },
        {
        key: 'chNameFilter',
        label: 'label.sith.stool.sithMesStoolVendor.filter.chName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enNameFilter',
        label: 'label.sith.stool.sithMesStoolVendor.filter.enName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emailFilter',
        label: 'label.sith.stool.sithMesStoolVendor.filter.email',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'telFilter',
        label: 'label.sith.stool.sithMesStoolVendor.filter.tel',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'deliverTermsFilter',
        label: 'label.sith.stool.sithMesStoolVendor.filter.deliverTerms',
        disabled: false,
        form: {
            type: 'select',
            options: getModelDeliverTerms()
    }
        },
        {
        key: 'taxRateFilter',
        label: 'label.sith.stool.sithMesStoolVendor.filter.taxRate',
        disabled: false,
        form: {
            type: 'select',
            options: getModelTaxRates()
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'vendor',
        label: 'label.sith.stool.sithMesStoolVendor.entity.vendor',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'centralDeletion',
        label: 'label.sith.stool.sithMesStoolVendor.entity.centralDeletion',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'companyCode',
        label: 'label.sith.stool.sithMesStoolVendor.entity.companyCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'companyCodeDeletion',
        label: 'label.sith.stool.sithMesStoolVendor.entity.companyCodeDeletion',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dataCommunicationLine',
        label: 'label.sith.stool.sithMesStoolVendor.entity.dataCommunicationLine',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'terms',
        label: 'label.sith.stool.sithMesStoolVendor.entity.terms',
        sortable: true,
        disabled: false,
        form: {
                type: 'select',
                options: getModelPaymentTerms()
        }
        },
        {
        key: 'chName',
        label: 'label.sith.stool.sithMesStoolVendor.entity.chName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enName',
        label: 'label.sith.stool.sithMesStoolVendor.entity.enName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'email',
        label: 'label.sith.stool.sithMesStoolVendor.entity.email',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'tel',
        label: 'label.sith.stool.sithMesStoolVendor.entity.tel',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'deliverTerms',
        label: 'label.sith.stool.sithMesStoolVendor.entity.deliverTerms',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            options: getModelDeliverTerms()
        }
        },
        {
        key: 'taxRate',
        label: 'label.sith.stool.sithMesStoolVendor.entity.taxRate',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            options: getModelTaxRates()
        }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolVendor.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesStoolVendor, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
